/**
 * Show the product card secondary image on long-press of the card link.
 *
 * The stretched `.full-unstyled-link` covers the card image, so we listen on
 * that link (not the img). A short tap still navigates; a long-press peeks
 * the second image and suppresses the click.
 */
(function () {
  const LINK_SELECTOR = '.card-wrapper a.full-unstyled-link';
  const MEDIA_SELECTOR = '.media.media--hover-effect';
  const HOVER_CLASS = 'is-hovering';
  const LONG_PRESS_MS = 350;
  const MOVE_THRESHOLD_PX = 14;

  let activeWrapper = null;
  let pressWrapper = null;
  let pressTimer = null;
  let startX = 0;
  let startY = 0;
  let longPressFired = false;

  function cardWithSecondaryFromLink(link) {
    const wrapper = link.closest('.card-wrapper');
    if (!wrapper) return null;

    const media = wrapper.querySelector(MEDIA_SELECTOR);
    if (!media) return null;

    if (media.getElementsByTagName('img').length < 2) return null;
    return wrapper;
  }

  function clearTimer() {
    if (!pressTimer) return;
    window.clearTimeout(pressTimer);
    pressTimer = null;
  }

  function clearHover() {
    clearTimer();
    pressWrapper = null;
    longPressFired = false;
    if (!activeWrapper) return;
    activeWrapper.classList.remove(HOVER_CLASS);
    activeWrapper = null;
  }

  function showHover(wrapper) {
    if (activeWrapper && activeWrapper !== wrapper) {
      activeWrapper.classList.remove(HOVER_CLASS);
    }
    activeWrapper = wrapper;
    wrapper.classList.add(HOVER_CLASS);

    const media = wrapper.querySelector(MEDIA_SELECTOR);
    if (!media) return;
    const images = media.getElementsByTagName('img');
    for (let i = 0; i < images.length; i++) {
      if (images[i].loading === 'lazy') images[i].loading = 'eager';
    }
  }

  document.addEventListener(
    'touchstart',
    function (event) {
      if (event.touches.length !== 1) return;

      clearTimer();
      longPressFired = false;

      const target = event.target;
      if (!target || typeof target.closest !== 'function') {
        clearHover();
        return;
      }

      const link = target.closest(LINK_SELECTOR);
      if (!link) {
        clearHover();
        return;
      }

      const wrapper = cardWithSecondaryFromLink(link);
      if (!wrapper) {
        clearHover();
        return;
      }

      pressWrapper = wrapper;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;

      pressTimer = window.setTimeout(function () {
        pressTimer = null;
        if (!pressWrapper) return;
        longPressFired = true;
        showHover(pressWrapper);
      }, LONG_PRESS_MS);
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'touchmove',
    function (event) {
      if (!pressWrapper || event.touches.length !== 1) return;

      const touch = event.touches[0];
      const movedX = Math.abs(touch.clientX - startX);
      const movedY = Math.abs(touch.clientY - startY);

      if (movedX > MOVE_THRESHOLD_PX || movedY > MOVE_THRESHOLD_PX) {
        clearTimer();
        pressWrapper = null;
        if (longPressFired) clearHover();
        longPressFired = false;
      }
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'touchend',
    function () {
      clearTimer();
      pressWrapper = null;
      // Keep peek visible after a completed long-press; clear incomplete presses.
      if (!longPressFired && activeWrapper) {
        // tap ended before long-press — nothing to clear from this press
      }
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'touchcancel',
    function () {
      clearTimer();
      pressWrapper = null;
    },
    { passive: true, capture: true }
  );

  // Long-press was a peek — don't follow the product link on the synthetic click.
  document.addEventListener(
    'click',
    function (event) {
      if (!longPressFired) return;
      const target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      if (!target.closest(LINK_SELECTOR)) return;

      event.preventDefault();
      event.stopPropagation();
      longPressFired = false;
    },
    { capture: true }
  );
})();
